import PropTypes from 'prop-types';
import React from 'react';
import styles from './SidebarFooterFtue.css';

const SidebarFooterFtue = props => {
  const { onKnowledgeCenterLinkClick } = props;

  return (
    <div className={styles.footerContainer}>
      <div className={styles.phone}>
        <i className="fa fa-phone" />
        <span> 1500970 </span>
      </div>
      <br />
      <div className="knowledge-center">
        <a
          href="https://mokaposhelp.zendesk.com/hc/en-us"
          target="_blank"
          onClick={onKnowledgeCenterLinkClick}
        >
          <button className={styles.btnInfo}>
            <i className={`fa fa-info-circle ${styles.infoIcon}`} />
          </button>
          <button className={styles.btnTutorial}>Tutorials & Help</button>
        </a>
      </div>
    </div>
  );
};

SidebarFooterFtue.propTypes = {
  onKnowledgeCenterLinkClick: PropTypes.func,
};

SidebarFooterFtue.defaultProps = {
  onKnowledgeCenterLinkClick: () => {},
};

export default SidebarFooterFtue;
